const getPostLaborUpdatesOnNats = (state) => {
  return !!state?.companySettings?.postLaborUpdatesOnNats;
};

export { getPostLaborUpdatesOnNats };
